import { getKyivDateTime } from './getKyivDateKey'

const compareTime = (left, right) => {
  const [leftHours, leftMinutes] = String(left).split(':').map(Number)
  const [rightHours, rightMinutes] = String(right).split(':').map(Number)
  const leftTotal = leftHours * 60 + leftMinutes
  const rightTotal = rightHours * 60 + rightMinutes

  if (leftTotal < rightTotal) {
    return -1
  }

  if (leftTotal > rightTotal) {
    return 1
  }

  return 0
}

const isDateInRange = ({ date, startedAt, finishedAt }) => {
  if (!startedAt || !finishedAt) {
    return false
  }

  return date >= startedAt && date <= finishedAt
}

export const isPromoScheduleActiveNow = (schedule, now = new Date()) => {
  if (!schedule || schedule.isArchived || schedule.isActive === false) {
    return false
  }

  const { date, time } = getKyivDateTime(now)

  if (!isDateInRange({ date, startedAt: schedule.startedAt, finishedAt: schedule.finishedAt })) {
    return false
  }

  const { timeFrom, timeTo } = schedule

  if (timeFrom == null && timeTo == null) {
    return true
  }

  if (timeFrom != null && compareTime(time, timeFrom) < 0) {
    return false
  }

  if (timeTo != null && compareTime(time, timeTo) > 0) {
    return false
  }

  return true
}

export default isPromoScheduleActiveNow
